import { connect } from 'react-redux';
import TermsAndConditions from './TermsAndConditions';
import { isAuthenticated } from '../../../state/reducers/LoginReducer';

export default connect((state) => ({
  isAuthenticated: isAuthenticated(state),
}))(TermsAndConditions);



// WEBPACK FOOTER //
// ./src/view/forms/TermsAndConditions/index.js